// City to coordinates mapping for major fund centre cities
export const cityCoordinates = {
  'New York': { lat: 40.7128, lng: -74.0060 },
  'Chicago': { lat: 41.8781, lng: -87.6298 },
  'London': { lat: 51.5074, lng: -0.1278 },
  'Frankfurt': { lat: 50.1109, lng: 8.6821 },
  'Paris': { lat: 48.8566, lng: 2.3522 },
  'Zurich': { lat: 47.3769, lng: 8.5417 },
  'Madrid': { lat: 40.4168, lng: -3.7038 },
  'Dubai': { lat: 25.2048, lng: 55.2708 },
  'Mumbai': { lat: 19.0760, lng: 72.8777 },
  'Colombo': { lat: 6.9271, lng: 79.8612 },
  'Singapore': { lat: 1.3521, lng: 103.8198 },
  'Hong Kong': { lat: 22.3193, lng: 114.1694 },
  'Bangkok': { lat: 13.7563, lng: 100.5018 },
  'Tokyo': { lat: 35.6762, lng: 139.6503 },
  'Seoul': { lat: 37.5665, lng: 126.9780 },
  'Sydney': { lat: -33.8688, lng: 151.2093 },
  'Melbourne': { lat: -37.8136, lng: 144.9631 },
  'Johannesburg': { lat: -26.2041, lng: 28.0473 },
  'Cairo': { lat: 30.0444, lng: 31.2357 },
  'Toronto': { lat: 43.6532, lng: -79.3832 },
  'Vancouver': { lat: 49.2827, lng: -123.1207 },
  'São Paulo': { lat: -23.5505, lng: -46.6333 }
};

// IANA timezone mapping for common cities
export const cityIANATimezones = {
  'New York': 'America/New_York',
  'Chicago': 'America/Chicago',
  'London': 'Europe/London',
  'Frankfurt': 'Europe/Berlin',
  'Paris': 'Europe/Paris',
  'Zurich': 'Europe/Zurich',
  'Madrid': 'Europe/Madrid',
  'Dubai': 'Asia/Dubai',
  'Mumbai': 'Asia/Kolkata',
  'Colombo': 'Asia/Colombo',
  'Singapore': 'Asia/Singapore',
  'Hong Kong': 'Asia/Hong_Kong',
  'Bangkok': 'Asia/Bangkok',
  'Tokyo': 'Asia/Tokyo',
  'Seoul': 'Asia/Seoul',
  'Sydney': 'Australia/Sydney',
  'Melbourne': 'Australia/Melbourne',
  'Johannesburg': 'Africa/Johannesburg',
  'Cairo': 'Africa/Cairo',
  'Toronto': 'America/Toronto',
  'Vancouver': 'America/Vancouver',
  'São Paulo': 'America/Sao_Paulo'
};

/**
 * Get coordinates for a city
 * @param {string} city - City name
 * @returns {Object|null} { lat, lng } or null
 */
export function getCityCoordinates(city) {
  if (!city) return null;
  return cityCoordinates[city] || null;
}

/**
 * Get IANA timezone for a city
 * @param {string} city - City name
 * @returns {string|null} IANA timezone or null
 */
export function getCityIANATimezone(city) {
  if (!city) return null;
  return cityIANATimezones[city] || null;
}
